import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/user',
    name: 'user.list',
    component: () => import('../views/users/List.vue')
  },
  {
    path: '/user/create',
    name: 'user.create',
    component: () => import('../views/users/Form.vue')
  },
  {
    path: '/user/edit/:id',
    name: 'user.edit',
    component: () => import('../views/users/Form.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/users/Login.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
